import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { CalendarLayoutComponent } from './calendar-layout/calendar-layout.component';
import { DayService, WeekService, WorkWeekService, MonthService, AgendaService, MonthAgendaService, TimelineViewsService, TimelineMonthService, ScheduleModule } from '@syncfusion/ej2-angular-schedule';
import { EffectsModule } from '@ngrx/effects';
import { CalendarEffects } from '../../redux/effects/calendar.effects';
import { CalendarScreenComponent } from './calendar-screen.component';
import { CalendarViewLayoutComponent } from './calendar-view-layout/calendar-view-layout.component';
import { AgGridModule } from 'ag-grid-angular';
import { CalendarScreenAddSideNoteComponent } from './calendar-screen-add-sidenote.component';
import { CalendarRefinebyComponent } from '../calendar-refineby/calendar-refineby.component';
import { CalendarRefinebyService } from '../../services/calendar-refineby.service';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        EffectsModule.forFeature([
            CalendarEffects
        ]),
        ScheduleModule,
        AgGridModule,
    ],
    declarations: [
        CalendarScreenComponent,
        CalendarLayoutComponent,
        CalendarViewLayoutComponent,
        CalendarScreenAddSideNoteComponent,
        CalendarRefinebyComponent
    ],
    exports: [
        CalendarScreenComponent,
    ],
    providers: [
        AgendaService,
        DayService,
        MonthService,
        MonthAgendaService,
        TimelineViewsService,
        TimelineMonthService,
        WeekService,
        WorkWeekService,
        CalendarRefinebyService
    ]
})
export class CalendarScreenModule {

}
